import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import { authReducer } from './auth/slice';
import { dictionariesApi } from './dictionary/dictionariesApi';
import { shopsApi } from './shops/shopsApi';
import { bagsApi } from './bags/bagsApi';
import { calendarApi } from './calendar/calendarApi';
import storage from 'redux-persist/lib/storage';
import { faqApi } from './faq/faqApi';
import { financeApi } from './financial/financeApi';
import { settingsApi } from './settings/settingsApi';
import { documentsApi } from './documents/documentsApi';
import { ordersApi } from './orders/ordersApi';
import { usersApi } from './users/usersApi';
import { statisticsApi } from './statistics/statisticsApi';
import { notificationApi } from './notification/notificationApi';
import { billingsApi } from './billings/billingsApi';
import { categoriesApi } from './categories/categoriesApi';
import { pricesApi } from './prices/pricesApi';
import { feedbacksApi } from './feedbacks/feedbacksApi';
import { appealsApi } from './appeals/appealsApi';
import { systemApi } from './system/systemApi';
import { reviewsApi } from './reviews/reviewsApi';
import { createTransform } from 'redux-persist';


const accessTransform = createTransform(
  (inboundState, key) => {
    return {
      token: inboundState.token,
      refreshToken: inboundState.refreshToken,
    };
  },
  (outboundState, key) => {
    return {
      token: outboundState.token,
      refreshToken: outboundState.refreshToken,
    };
  },
  { whitelist: ['access'] }
);


const authPersistConfig = {
  key: 'auth1',
  storage,
  whitelist: ['access'],
  transforms: [accessTransform],
};

export const store = configureStore({
  reducer: {
    auth: persistReducer(authPersistConfig, authReducer),
    [dictionariesApi.reducerPath]: dictionariesApi.reducer,
    [shopsApi.reducerPath]: shopsApi.reducer,
    [bagsApi.reducerPath]: bagsApi.reducer,
    [calendarApi.reducerPath]: calendarApi.reducer,
    [faqApi.reducerPath]: faqApi.reducer,
    [financeApi.reducerPath]: financeApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [statisticsApi.reducerPath]: statisticsApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [billingsApi.reducerPath]: billingsApi.reducer,
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [pricesApi.reducerPath]: pricesApi.reducer,
    [feedbacksApi.reducerPath]: feedbacksApi.reducer,
    [appealsApi.reducerPath]: appealsApi.reducer,
    [systemApi.reducerPath]: systemApi.reducer,
    [reviewsApi.reducerPath]: reviewsApi.reducer,
  },

  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      serializableCheck: 
        false
      
    }),
    dictionariesApi.middleware,
    shopsApi.middleware,
    bagsApi.middleware,
    calendarApi.middleware,
    faqApi.middleware,
    financeApi.middleware,
    settingsApi.middleware,
    documentsApi.middleware,
    ordersApi.middleware,
    statisticsApi.middleware,
    notificationApi.middleware,
    usersApi.middleware,
    billingsApi.middleware,
    categoriesApi.middleware,
    pricesApi.middleware,
    feedbacksApi.middleware,
    appealsApi.middleware,
    systemApi.middleware,
    reviewsApi.middleware,
  ],
});

export const persistor = persistStore(store);
